import React from 'react';
import Chart from '../components/Chart';
import AutoComplete from '../components/AutoComplete';

const LeadWater = (props) => {
    // var cloned = JSON.parse(JSON.stringify(props.chartdata))
    //
    // cloned.forEach(function(r) {
    //     if (r.charttype === "water") {
    //         r.chartnumber = (r.chartnumber * 100).toFixed(0);
    //     }
    // })
    var sorted = props.testdata.sort(function(a,b) {
        return b.reports - a.reports
    }).slice(0,10);

    return (<div>
        <div className="white-box water">
            <h1>Lead in drinking water</h1>
            <div className="detailsection">
                <p>Schools built before 1986 are more likely to have pipes, fixtures and soldering that contains lead, which can leech into the water supply. The EPA says the concentration of lead in drinking water should not exceed an &ldquo;action level&rdquo; of 15 parts per billion (ppb). The district follows a lower threshold, 10 ppb. Ingesting slight amounts of lead can cause loss of IQ and behavioral problems in children.</p>
                <p>There is no safe level of lead exposure. The only way to know for sure if water from old pipes is safe to drink is by having a certified laboratory test it.</p>
                <p>Young children, whose brains and bodies are rapidly developing, are most susceptible to damage from lead-contaminated drinking water. Lead can accumulate in the body over time and can reduce IQ and trigger behavioral problems such as attention deficit disorder and impulsivity. Pregnant women should also avoid water with elevated lead.</p>
                <p>Under EPA regulations, lead concentrations in drinking water should not exceed the agency&rsquo;s &ldquo;action level&rdquo; of 15 parts per billion (ppb). The district adopted a lower threshold of 10 ppb in wake of the 2015 lead-contaminated water crisis in Flint, Mich. The Philadelphia School District began testing water outlets in all schools in October 2016.</p>
                <p>Nearly 10 percent of the 2,800 water fountains tested were found to be unsafe. Any water sources that exceeded the district&rsquo;s limit were turned off. Parents were notified, and the results of all water sources tested were <a href="https://www.philasd.org/capitalprograms/programsservices/environmental/water-testing/">published online</a>.</p>
                <p>The district has begun installing hydration stations -- water fountains that filter out lead -- on every floor of each district-run school. Officials said they plan to test the water every five years. For drinking water concerns, contact the school district&rsquo;s <a href="https://www.philasd.org/capitalprograms/programsservices/environmental/environmental-programs-services/">Department of Environmental Programs</a> &amp; Services at 215-400-4730.</p>


                <hr/>
                <h3>Schools with highest number of elevated water outlets in 2016-17</h3>
                <Chart newdata={sorted} charttype="water" chartlabel="Number of reports"/>
            </div>
        </div>

        {/* <hr/>
        <div className="detailsection">


        </div> */}

        <div id="inputwrapper">
            <AutoComplete getUrl={props.match} data={props.data} placeholder="Search for another school..." />
        </div>
    </div>);
}

export default LeadWater;



// WEBPACK FOOTER //
// ./src/routes/LeadWater.js